export const labModuleApi = {
  forms: {
    create: () => '/v3/lab-form/create',
    update: id => `/v3/lab-form/update/${id}`,
    getById: id => `/v3/lab-form/getById/${id}`,
    getAll: () => '/v3/lab-form/getAll',
    getAllWithTree: () => '/v3/lab-form/getAllWithTree',
    remove: id => `/v3/lab-form/delete/${id}`
  },
  categories: {
    create: () => '/v3/lab-category/create',
    update: id => `/v3/lab-category/update/${id}`,
    getById: id => `/v3/lab-category/getById/${id}`,
    getAllByFormId: formId => `/v3/lab-category/getAll/${formId}`,
    remove: id => `/v3/lab-category/delete/${id}`
  },
  subCategories: {
    create: () => '/v3/lab-sub-category/create',
    update: id => `/v3/lab-sub-category/update/${id}`,
    getById: id => `/v3/lab-sub-category/getById/${id}`,
    getAllByCategoryId: categoryId => `/v3/lab-sub-category/getAll/${categoryId}`,
    remove: id => `/v3/lab-sub-category/delete/${id}`
  },
  elements: {
    create: () => '/v3/lab-element/create',
    update: id => `/v3/lab-element/update/${id}`,
    getById: id => `/v3/lab-element/getById/${id}`,
    getAllBySubCategoryId: subCategoryId => `/v3/lab-element/getAll/${subCategoryId}`,
    remove: id => `/v3/lab-element/delete/${id}`,
    addMultiple: () => '/v3/lab-element/add-multiple',
    updateMultiple: () => '/v3/lab-element/update-multiple'
  },
  visitResults: {
    create: () => '/v3/visit/internal-result-upload',
    getAll: itemId => `/v3/visit/internal-result-upload/all?item_id=${itemId}`
  },
  generalResults: {
    create: () => '/v3/general/internal-result-upload',
    getAll: patientId => `/v3/general/internal-result-upload/all?patient_id=${patientId}`
  }
}

export const filterFormsByRequestType = (forms = [], requestType) => {
  if (!requestType) return forms
  return forms.filter(form => form?.request_type === requestType)
}

export const normalizeLabFormTree = form => {
  if (!form) return form

  const categories = (form?.categories || []).map(category => ({
    ...category,
    form_id: category?.form_id || form?.id
  }))

  const subCategories = categories.flatMap(category =>
    (category?.sub_categories || []).map(subCategory => ({
      ...subCategory,
      category_id: subCategory?.category_id || category?.id
    }))
  )

  const formElements = subCategories.flatMap(subCategory =>
    (subCategory?.elements || []).map(element => ({
      ...element,
      sub_category_id: element?.sub_category_id || subCategory?.id
    }))
  )

  return {
    ...form,
    categories,
    sub_categories: subCategories,
    form_elements: formElements
  }
}

export const normalizeLabFormsTree = (forms = []) =>
  forms.map(normalizeLabFormTree)
